import { Component } from '@angular/core';

@Component({ standalone: false, selector: 'app-simple-page-template',
  templateUrl: './simple-page-template.component.html',
  styleUrls: ['./simple-page-template.component.scss']
})
export class SimplePageTemplateComponent {


}
